import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { services } from '../data/mockData';
import { Eye, Sparkles } from 'lucide-react';

const BeauteRegard = () => {
  const navigate = useNavigate();

  const handleReserve = (serviceName) => {
    navigate(`/reservation?service=${encodeURIComponent(serviceName)}`);
  };

  return (
    <div className="page-service">
      {/* Hero Header */}
      <section className="service-hero">
        <div className="service-hero-pattern" />
        <div className="service-hero-content">
          <h1 className="service-hero-title">Mes Prestations</h1>
          <h2 className="service-hero-subtitle-large">Beauté du Regard</h2>
          <Eye className="hero-icon" size={48} strokeWidth={1.5} />
          <p className="service-hero-description">
            Rehaussement de cils et restructuration des sourcils pour sublimer votre regard
          </p>
        </div>
      </section>

      {/* Services List */}
      <section className="service-list-section beaute-regard-list">
        <div className="container-service">
          {services.beauteRegard.map((service, index) => (
            <div key={service.id} className="service-item compact-item">
              <div className="service-item-content">
                <div className="service-item-header">
                  {index === 3 ? (
                    <Sparkles className="service-icon highlight" size={24} />
                  ) : (
                    <Eye className="service-icon" size={24} />
                  )}
                  <div>
                    <h2 className="service-item-title">{service.name}</h2>
                    {service.subtitle && (
                      <h3 className="service-item-subtitle-small">{service.subtitle}</h3>
                    )}
                    {service.description && (
                      <p className="service-item-description-small">{service.description}</p>
                    )}
                    <button
                      onClick={() => handleReserve(service.name)}
                      className="btn-reserve-service"
                      style={{marginTop: '1rem'}}
                    >
                      Réserver
                    </button>
                  </div>
                </div>
              </div>
              
              <div className="service-item-price">
                <div className={`price-badge ${index === 3 ? 'highlight' : ''}`}>
                  <span className="price-amount">{service.price}€</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Info Section */}
      <section className="info-section">
        <div className="container-service">
          <div className="info-card">
            <h3 className="info-title">Des yeux sublimés naturellement</h3>
            <p className="info-text">
              Nos techniques de rehaussement de cils et de restructuration des sourcils 
              mettent en valeur votre beauté naturelle pour un regard intensifié et harmonieux.
            </p>
            <div className="info-features">
              <div className="info-feature">
                <span className="info-icon">✨</span>
                <span>Résultat naturel</span>
              </div>
              <div className="info-feature">
                <span className="info-icon">⏱️</span>
                <span>Longue durée</span>
              </div>
              <div className="info-feature">
                <span className="info-icon">🎨</span>
                <span>Technique professionnelle</span>
              </div>
              <div className="info-feature">
                <span className="info-icon">💫</span>
                <span>Regard sublimé</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="service-cta">
        <div className="service-cta-content">
          <h3 className="service-cta-title">Sublimez votre regard</h3>
          <p className="service-cta-text">
            RDV en privé ou dans le lien dans ma bio
          </p>
          <Link to="/reservation" className="btn-primary">
            Réserver maintenant
          </Link>
        </div>
      </section>
    </div>
  );
};

export default BeauteRegard;
